import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
  useImperativeHandle,
  createRef,
  useContext,
} from 'react';
import { Box, ButtonBase, Checkbox, FormControlLabel, makeStyles, Typography } from '@material-ui/core';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import * as Yup from 'yup';
import _ from 'lodash';
import { bedStatusAPI } from '../../../../apis';
import { ColumnItem } from '../../../../components';
import AutoCompleteMultiCheckbox from '../../../../components/AutoCompleteMultiCheckbox';
import {
  CompletedIcon,
  DateTimeIcon,
  OutstandingIcon,
  DocIcon,
  UpdateIcon,
  WithdrawIcon,
  CloseIcon,
  DropUpIcon,
  DropDownIcon,
} from '../../../../components/Icon';
import { i18n } from '../../../../language';
import Newbooking from '../PopWindows/Newbooking';
import { classNames, downloadFileById, getUserInfo, isRequest } from '../../../../utils';
import { checkSubmitData } from '../../../../utils/check';
import { alertMsg, ResponseCommCodeEnum } from '../../../../apis/commlogic';
import { BEDSTATUS_OUTSTANDING_TRANSFER_IN } from '../../../../comm/constant';
import { LoginPop } from '../../../../components/Login';
import { useActionableTicketReminder } from '../../../../utils/hooks';
import { BedStatusStatisticContext, bsTransferInStatisticRef } from '../..';
import exportPwdExcel from '../../../../utils/exportPwdExcel';
import { baseCssBooking } from '../PopWindows/baseCss';
import { revampTableList } from '../../../../utils/newBedStatusUtil';
import DateFilter from './DateFilter';
import { initEndDate, initStartDate } from './Admission';
import BSTransferInTable from './TransferInTable/TransferInTable';

const useStyles = makeStyles((theme) => ({
  root: {
    background: '#fff',
    borderRadius: '0 0.937rem 0.937rem 0.937rem',
    overflowY: 'auto',
    margin: '0 3.375rem 0',
    zIndex: 10,
    display: 'flex',
    flexDirection: 'column',
    flex: '1',
    height: 'calc(100vh - 4.375rem - 4.2rem - 1.25rem - 1.75rem)',
    overflow: 'auto',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '1.25rem 1.875rem',
    borderBottom: 'solid 1px #ddd',
  },
  bookColumn: {
    flexBasis: 'unset',
    padding: '1.844rem 1.875rem 1.875rem',
  },
  select: {
    width: '9.375rem',
    height: '2.5rem',
    opacity: 0.85,
    flexGrow: 0,
    '& .MuiOutlinedInput-notchedOutline': {
      borderRadius: '0.5rem',
      boxShadow: '-1px 4px 10px 0 rgba(221, 232, 251, 0.58)',
      border: 'solid 1px #ddd',
    },
    '& .MuiSelect-root': {
      lineHeight: '2.5rem',
      fontFamily: 'NotoSans-Medium',
      fontSize: '1rem',
      fontWeight: '500',
      color: '#2e4469',
    },
  },
  filter: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#2e4469',
    whiteSpace: 'nowrap',
  },
  ward: {
    fontFamily: 'NotoSans-Bold',
    fontSize: '1.5rem',
    fontWeight: 'bold',
    color: '#2e4469',
  },
  newBooking: {
    width: '10rem',
    height: '3rem',
    borderRadius: '0.625rem',
    background: '#538fff',
    fontSize: '1rem',
    fontWeight: '500',
    fontFamily: 'NotoSans-Medium',
    color: '#fff',
  },
  dateTimeIcon: {
    fontSize: '1.25rem',
    marginRight: '0.188rem',
  },
  columnItem: {
    width: '8.925rem',
    margin: '0 2rem',
    [theme.breakpoints.only('xs')]: {
      width: '100%',
    },
    marginLeft: '0.5rem',
    whiteSpace: 'nowrap',
  },
  columnBox: {
    display: 'flex',
    // justifyContent: 'space-between',
    justifyContent: 'start',
    flexWrap: 'wrap',
    margin: '0 1.875rem 1rem 1.875rem',
    padding: '0.175rem 0rem 0.175rem 0.175rem',
    borderRadius: '0.937rem',
    border: '1.2px solid rgb(228, 231, 235)',
    alignItems: 'center',
  },
  filterBox: {
    // display: 'flex',
    // justifyContent: 'space-between',
    padding: '1rem',
    paddingLeft: '1.875rem',
    borderBottom: 'solid 1px #ddd',
  },
  errorMsg: {
    margin: '3px 0.825rem 0 0.825rem',
    color: '#f44336',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
  },
  filterStatusTitle: {
    fontSize: '1rem',
    color: '#2e4469',
    fontFamily: 'NotoSans-Medium',
    fontWeight: '500',
    marginRight: '0.625rem',
  },
  detailBtn: ({ detailOpen }) => ({
    fontFamily: 'NotoSans-Medium',
    color: detailOpen ? '#7d86a9' : '#fff',
    fontSize: '1rem',
    width: '11.25rem',
    minWidth: '11.25rem',
    height: '2rem',
    position: 'absolute',
    top: '-1rem',
    left: '1.75rem',
    border: 'solid 1px #e4e7eb',
    borderRadius: '4px',
    zIndex: '999',
    backgroundColor: detailOpen ? '#fff' : '#7d86a9',
  }),
  dropIcon: {
    fontSize: '0.875rem',
    marginLeft: '1rem',
  },
  datepicker: {
    '& .MuiInputBase-root': {
      borderRadius: '0.5rem',
      backgroundColor: theme.palette.font.white,
      borderColor: '#e4e7eb',
      paddingLeft: '0.3rem',
    },
    '& .MuiInputBase-input': {
      fontFamily: 'NotoSans-Medium',
      fontSize: '0.919rem',
      letterSpacing: '0',
      color: theme.palette.font.sub,
      fontWeight: '500',
      marginLeft: '-0.3rem',
      width: '96px',
      paddingRight: '0',
    },
  },
  disabledStyle: {
    '& .MuiInputBase-root': {
      backgroundColor: '#f5f5f5',
    },
  },
}));

const initData = (data, showBusStop) => {
  return _.flatMap(data, (obj) => [
    { ...obj, busStopRow: false, display: true },
    { ...obj, busStopRow: true, display: showBusStop },
  ]);
};

export const bsTransferInRef = createRef();

function InternalBooking({ loginInfo, userRole, rouList, padding = '0 1.875rem' }) {
  const [, needRefresh] = useActionableTicketReminder('msg', 'BS');
  // transferINStatus
  const transferInStatusList = [
    { text: 'Pending Accept', value: 'PFYA' },
    { text: i18n.t('BEDSTATUS_DECLINED'), value: 'DL' },
    { text: i18n.t('BEDSTATUS_OUTSTANDING'), value: 'O' },
    { text: i18n.t('BEDSTATUS_WARD_READY'), value: 'WR' },
    { text: i18n.t('BEDSTATUS_COMPLETED_SINCE_24HOURS_AGO'), value: 'C' },
    { text: 'Withdrawn', value: 'D' },
  ];
  const outstanding = useMemo(() => {
    const session = sessionStorage.getItem(BEDSTATUS_OUTSTANDING_TRANSFER_IN);
    let result = null;
    try {
      result = JSON.parse(session);
    } catch {}
    sessionStorage.removeItem(BEDSTATUS_OUTSTANDING_TRANSFER_IN);
    return result;
  }, []);
  // outstanding
  const outstandingArr = outstanding?.status?.map((item) =>
    _.find(transferInStatusList, (statusItem) => statusItem.value === item)
  );
  const [isShowPop, setIsShowPop] = useState(false);
  const [editData, setEditData] = useState();
  const [checkDataFlag, setCheckDataFlag] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);
  const classes = useStyles({ detailOpen });
  const baseClasses = baseCssBooking();
  const { refresh: refresh_btn } = useContext(BedStatusStatisticContext);
  const columnTitles = [
    'Pending Accept',
    // 'Redirected',
    'Declined',
    i18n.t('BEDSTATUS_OUTSTANDING'),
    i18n.t('BEDSTATUS_COMPLETED_SINCE_24HOURS_AGO'),
    // 'Hold',
    'Withdrawn',
  ];
  const iconBgColors = [
    '#FA8A82',
    // '#EE9833',
    '#FF655C',
    '#7FD6F1',
    '#28D2AB',
    // '#A6B0C3',
    '#878687',
  ];
  const PAGESIZE = 20;
  const language = useSelector((state) => state.settings.language);
  const [isLoading, setIsLoading] = useState(true);
  const [transferInStatus, setTransferInStatus] = useState(outstanding ? outstandingArr : []);
  const [isNewBookingPop, setIsNewBookingPop] = useState(false);
  const [loginPopup, setLoginPopup] = useState(false);
  const isLogin = useSelector((state) => state.loginInfo.flag);
  const onChangeHandle = useCallback(
    (key) => {
      return (event) => {
        if (key === 'select') {
          setTransferInStatus(event);
        }
        setIsLoading(true);
      };
    },
    [transferInStatus]
  );
  // set
  const closePop = () => {
    setIsNewBookingPop(false);
  };
  const showPop = () => {
    if (isLogin) {
      setIsNewBookingPop(true);
    } else {
      setLoginPopup(true);
    }
  };

  const handleOpenDetail = () => {
    setDetailOpen(!detailOpen);
  };
  const [startDate, setStartDate] = useState(initStartDate(outstanding));
  const [stopDate, setStopDate] = useState(initEndDate(outstanding));
  const [AdmDateTbc, setAdmDateTbc] = useState(false);
  const setDate = (type) => {
    return (event) => {
      if (type === 'start') {
        setStartDate(event);
      } else if (type === 'stop') {
        setStopDate(event);
      }
      setIsLoading(true);
    };
  };

  const selectTab = (status) => {
    setTransferInStatus(
      _.map(status, (item) => _.find(transferInStatusList, (statusItem) => statusItem.value === item))
    );
    if (_.find(status, (item) => item === 'O')) {
      setStartDate(moment(moment().subtract(7, 'days').format('yyyy-MM-DD 00:00:00').valueOf()));
      setStopDate(moment(moment().add(1, 'days').format('yyyy-MM-DD 23:59:59').valueOf()));
    } else {
      setStartDate(null);
      setStopDate(null);
    }
  };
  useImperativeHandle(bsTransferInRef, () => ({
    selectTab,
  }));

  const [BsBookingList, setBsBookingList] = useState([]);
  const [BsMlookupList, setBsMlookupList] = useState(null);
  const [count, setCount] = useState(null);
  const getBsBookingList = async (pageSize, pageNo) => {
    try {
      const status = () => {
        if (transferInStatus.length !== 9 && transferInStatus.length !== 0) {
          let transferINStatusArr = transferInStatus.map((item) => item.value);
          let transferINStatusStr = transferINStatusArr.join(',');
          return transferINStatusStr; // 将新数组转换为字符串，元素之间用逗号隔开
        }
        return null;
      };
      const { result } = await bedStatusAPI.getBsBookingList({
        startDate: startDate ? moment(startDate.format('yyyy-MM-DD 00:00:00')).valueOf() : null,
        endDate: stopDate ? moment(stopDate.format('yyyy-MM-DD 23:59:59')).valueOf() : null,
        nonDate: AdmDateTbc ? 1 : 0,
        pageNo: pageNo,
        pageSize: pageSize,
        status: status(),
      });
      // Decrypt HKIDs (revampTableList returns the resolved array)
      const decryptedData = await revampTableList(result.data);
      setCount(result?.count ?? 0);
      setColumnData([
        { ...columnData[0], text: result?.pendingFYACount ?? 0 },
        // { ...columnData[1], text: result?.redirectedCount ?? 0 },
        { ...columnData[1], text: result?.declinedCount ?? 0 },
        { ...columnData[2], text: result?.outstandingCount ?? 0 },
        { ...columnData[3], text: result?.completedCount ?? 0 },
        // { ...columnData[5], text: result?.holdCount ?? 0 },
        { ...columnData[4], text: result?.withdrawnCount ?? 0 },
      ]);
      const newBsBookingList = [
        ...BsBookingList.slice(0, (pageNo - 1) * pageSize * 2),
        ...initData(decryptedData, false),
      ];
      setBsBookingList(newBsBookingList);
      return decryptedData;
    } catch (e) {
      console.log('-------------', e);
    }
  };

  const [errorMsg, setErrorMsg] = useState(null);
  const schema = {
    // startDate: stopDate
    //   ? Yup.date()
    //       .max(
    //         stopDate,
    //         i18n.t('ALERT_START_DATE_CANNOT_BE_LATER_THAN_END_DATE_CANNOT_BE_LATE_THAN_ENDDATE', {
    //           value: startDate?.format('DD-MM-yyyy'),
    //         })
    //       )
    //       .min(
    //         moment(stopDate).subtract(100, 'days'),
    //         i18n.t('BEDSTATUS_START_DATE_AND_END_DATE_CANNOT_BE_OVER_100_DAYS')
    //       )
    //       .typeError(i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('EHANDOVER_START_DATE') }))
    //   : Yup.date().typeError(i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('EHANDOVER_START_DATE') })),
    // stopDate: Yup.date().typeError(
    //   i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('EHANDOVER_END_DATE') })
    // ),
  };

  useEffect(() => {
    (async () => {
      if (checkDataFlag) {
        try {
          await checkSubmitData(Yup.object().shape(schema), { startDate, stopDate });
          setErrorMsg({ ...errorMsg, startDate: null, stopDate: null });
        } catch (e) {
          setErrorMsg({ ...errorMsg, ...e });
        }
      }
    })();
  }, [language]);
  const [refresh, setRefresh] = useState(false);
  useEffect(() => {
    (async () => {
      if (isLoading) {
        try {
          await checkSubmitData(Yup.object().shape(schema), { startDate, stopDate });
          const getBsMlookupList = await bedStatusAPI.getBsMlookupList();
          setBsMlookupList(getBsMlookupList.result);
          await getBsBookingList(PAGESIZE, 1);
          setErrorMsg({ ...errorMsg, startDate: null, stopDate: null });
        } catch (e) {
          setErrorMsg({ ...errorMsg, ...e });
        }
      }
    })();
  }, [startDate, stopDate, isLoading, transferInStatus, refresh, needRefresh, refresh_btn, rouList, AdmDateTbc]);

  useEffect(() => {
    if (isRequest(loginInfo, userRole)) {
      setCount(null);
      setBsBookingList([]);
    }
  }, [rouList]);

  const [columnData, setColumnData] = useState([
    { id: 0, text: 0, IconCom: UpdateIcon },
    // { id: 1, text: 0, IconCom: RedirectedIcon },
    { id: 2, text: 0, IconCom: CloseIcon, padding: '0.5rem' },
    { id: 3, text: 0, IconCom: OutstandingIcon },
    { id: 4, text: 0, IconCom: CompletedIcon },
    // { id: 5, text: 0, IconCom: HoldIcon },
    { id: 6, text: 0, IconCom: WithdrawIcon },
  ]);

  const addSaveHandle = async (requestVal) => {
    try {
      await bedStatusAPI.postCreateBsBooking({ ...requestVal, wardId: loginInfo.wardId });
      await getBsBookingList(PAGESIZE, 1);
      closePop();
    } catch (error) {
      if (error.statusCode === ResponseCommCodeEnum.BED_VERSION) {
        alertMsg(
          i18n.t(
            'BEDSTATUS_THE_TRANSFER_IN_DETAIL_WAS_CHANGED_BY_OTHER_WARDPLACE_USER_PLEAS_REFRESH_WEB_PAGE_TO_GET_THE_LATEST_TRANSFER_IN_INFO_AND_CHECK_IF_FURTHER_ACTION_IS_REQUIRED'
          ),
          _.uniqueId('warning_'),
          'warning'
        );
      } else {
        console.log(`---------${error}------------`);
      }
    }
  };
  const editSaveHandle = async (requestVal) => {
    try {
      await bedStatusAPI.postUpdateBsBooking(requestVal);
      if (!editData) return false;

      const index = _.findIndex(BsBookingList, (item) => item.transferRequestId === editData.transferRequestId);
      const pageNo = Math.ceil(Math.ceil((index + 1) / 2) / PAGESIZE);
      await getBsBookingList(PAGESIZE, pageNo);
      return true;
    } catch (error) {
      if (error.statusCode === ResponseCommCodeEnum.BED_VERSION) {
        alertMsg(
          i18n.t(
            'BEDSTATUS_THE_TRANSFER_IN_DETAIL_WAS_CHANGED_BY_OTHER_WARDPLACE_USER_PLEAS_REFRESH_WEB_PAGE_TO_GET_THE_LATEST_TRANSFER_IN_INFO_AND_CHECK_IF_FURTHER_ACTION_IS_REQUIRED'
          ),
          _.uniqueId('warning_'),
          'warning'
        );
      } else {
        console.log(`---------${error}------------`);
      }
    }
  };

  const exportExcelHandle = async (protectKey) => {
    await downloadFileById(
      () => {
        return bedStatusAPI.getExportBsTransferRequest({
          wardId: loginInfo.wardId,
          startDate: startDate ? moment(startDate.format('yyyy-MM-DD 00:00:00')).valueOf() : null,
          endDate: stopDate ? moment(stopDate.format('yyyy-MM-DD 23:59:59')).valueOf() : null,
          nonDate: AdmDateTbc ? 1 : 0,
          status:
            transferInStatus.length === 9 && transferInStatus.length === 0
              ? null
              : transferInStatus.map((i) => i.value).join(','),
          protectKey,
        });
      },
      (res) => {
        return `bedstatus Export Excel_${moment().valueOf()}`;
      }
    );
  };

  const getWardName = () => {
    const userInfo = getUserInfo();
    return userInfo?.wardName ?? '';
  };

  const bsMlookupListStatus = useMemo(() => {
    let addStatus = [
      { lookUpName: i18n.t('BEDSTATUS_OUTSTANDING'), lookUpValue: 'O' },
      { lookUpName: i18n.t('BEDSTATUS_COMPLETED_SINCE_24HOURS_AGO'), lookUpValue: 'C' },
      { lookUpName: 'Withdrawn', lookUpValue: 'D' },
      { lookUpName: i18n.t('BEDSTATUS_WARD_READY'), lookUpValue: 'WR' },
    ];
    return addStatus;
  }, [BsMlookupList]);
  // Page auto refresh (every 5 mins)
  useEffect(() => {
    const timer = setInterval(() => {
      (async () => {
        await getBsBookingList(PAGESIZE, 1);
      })();
    }, 60 * 1000);
    return () => {
      clearInterval(timer);
    };
  }, [startDate, stopDate, transferInStatus, needRefresh, refresh, refresh_btn, AdmDateTbc]);

  const handleScroll = useCallback(
    ({ scrollTop, clientHeight, scrollHeight }) => {
      if (scrollTop + clientHeight + 1 >= scrollHeight) {
        if (BsBookingList.length < count * 2) {
          const pageNo = Math.ceil((BsBookingList.length / 2 + 1) / PAGESIZE);
          getBsBookingList(PAGESIZE, pageNo);
        }
      }
    },
    [BsBookingList, count]
  );

  const handleEditEADM = useCallback(() => {
    sessionStorage.setItem(
      BEDSTATUS_OUTSTANDING_TRANSFER_IN,
      JSON.stringify({
        startTime: moment(startDate).format('yyyy-MM-DD 00:00:00'),
        stopTime: moment(stopDate).format('yyyy-MM-DD 23:59:59'),
        status: _.map(transferInStatus, (item) => item.value),
        nonDate: AdmDateTbc,
      })
    );
  }, [startDate, stopDate, transferInStatus]);

  const handleUpdateSingleData = (transferRequestId) => {
    const currentIndex = _.findIndex(BsBookingList, (item) => item.transferRequestId === transferRequestId);
    const currentPage = Math.ceil(Math.ceil((currentIndex + 1) / 2) / PAGESIZE);
    getBsBookingList(PAGESIZE, currentPage);
  };

  return (
    <div className={classes.root}>
      <div>
        <div className={classes.filterBox}>
          <Box display="flex" justifyContent="space-between">
            <Box display="flex" alignItems="center">
              <Box>
                <FormControlLabel
                  id="bed_transferpop_on_oxygen"
                  control={<Checkbox />}
                  label="Adm. Date to be confirmed"
                  className={baseClasses.checkBox}
                  checked={AdmDateTbc}
                  onChange={(event) => setAdmDateTbc(event.target.checked)}
                />
              </Box>
              <Box>
                <DateFilter
                  setStartDate={(val) => {
                    setDate('start')(val);
                    setCheckDataFlag(true);
                  }}
                  setEndDate={(val) => {
                    setDate('stop')(val);
                    setCheckDataFlag(true);
                  }}
                  startDate={startDate}
                  stopDate={stopDate}
                  errorMsg={{
                    startDate:
                      errorMsg?.startDate ===
                      i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('EHANDOVER_START_DATE') })
                        ? i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('EHANDOVER_START_DATE') })
                        : null,
                    stopDate: errorMsg?.stopDate,
                  }}
                  startDatePickProps={{
                    disabled: AdmDateTbc,
                    className: classNames(classes.datepicker, AdmDateTbc && classes.disabledStyle),
                  }}
                  stopDatePickProps={{
                    disabled: AdmDateTbc,
                    className: classNames(classes.datepicker, AdmDateTbc && classes.disabledStyle),
                  }}
                />
                {errorMsg?.startDate !==
                  i18n.t('DUTYASSIGN_TEMPLATE_AUTORULE_ERROR', { value: i18n.t('EHANDOVER_START_DATE') }) &&
                errorMsg?.startDate ? (
                  <Typography className={classes.errorMsg}>{errorMsg?.startDate ?? ''}</Typography>
                ) : (
                  ''
                )}
              </Box>
              <Box display="flex" justifyContent="center" alignItems="center" ml="1.6rem">
                <div className={classes.filterStatusTitle}>{i18n.t('BEDSTATUS_STATUS')}:</div>
                <AutoCompleteMultiCheckbox
                  id="bed_transferOut_status"
                  itemList={transferInStatusList}
                  placeholder={i18n.t('BEDSTATUS_SELECT_FROM_BELOW_ITEMS')}
                  value={transferInStatus}
                  onChange={onChangeHandle('select')}
                  className={classes.filterStatus}
                  height="2.6rem"
                  width="12rem"
                />
              </Box>
            </Box>
            <Box display="flex">
              <ButtonBase
                id="bed_excel_btn1"
                className={classes.newBooking}
                style={{ marginRight: '1.25rem', marginLeft: '1.25rem' }}
                onClick={() => {
                  if (!isLogin) {
                    setLoginPopup(true);
                    return;
                  }
                  exportPwdExcel(exportExcelHandle)();
                }}
              >
                <DocIcon className={classes.dateTimeIcon} />
                <Typography>{i18n.t('BEDSTATUS_EXPORT_EXCEL')}</Typography>
              </ButtonBase>
              <ButtonBase id="bed_new_btn1" className={classes.newBooking} onClick={showPop}>
                <DateTimeIcon className={classes.dateTimeIcon} />
                <Typography>{i18n.t('BEDSTATUS_NEW_REQUEST')}</Typography>
              </ButtonBase>
            </Box>
          </Box>
          {detailOpen && (
            <Box display="flex" alignItems="center" marginTop="1rem">
              <Typography className={classes.ward}>{getWardName()}</Typography>
              <div style={{ display: 'flex' }}>
                <div className={classes.columnBox}>
                  {columnData.map((item, index) => {
                    return (
                      <ColumnItem
                        key={item.id}
                        {...item}
                        title={columnTitles[index]}
                        iconBgColor={iconBgColors[index]}
                        className={classes.columnItem}
                        xs={3}
                        sm={3}
                        md={3}
                      />
                    );
                  })}
                </div>
              </div>
            </Box>
          )}
        </div>
      </div>
      <div style={{ position: 'relative' }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <ButtonBase className={classes.detailBtn} onClick={handleOpenDetail}>
            Statistic Detail
            {detailOpen ? <DropUpIcon className={classes.dropIcon} /> : <DropDownIcon className={classes.dropIcon} />}
          </ButtonBase>
        </Box>
      </div>
      <Box mt="1rem" p={padding} height="100%" minWidth="80rem" display="flex" flexDirection="column">
        <BSTransferInTable
          data={BsBookingList}
          handleScroll={handleScroll}
          openEdit={(data) => {
            if (isLogin) {
              setEditData(data);
              setIsShowPop(true);
            } else {
              setLoginPopup(true);
            }
          }}
          bedstatus={true}
          handleEditEADM={handleEditEADM}
          handleUpdateSingleData={handleUpdateSingleData}
          type="TRANSFER"
        />
      </Box>
      {isNewBookingPop ? (
        <Newbooking
          open={isNewBookingPop}
          closePop={closePop}
          title={i18n.t('BEDSTATUS_TRANSFER_IN_BUTTON')}
          saveHandle={addSaveHandle}
          bsMlookupList={BsMlookupList}
          bsMlookupListStatus={bsMlookupListStatus}
          wardLabel={i18n.t('BEDSTATUS_TI_UNIT')}
        />
      ) : (
        ''
      )}
      {isShowPop && (
        <Newbooking
          open={isShowPop}
          closePop={() => setIsShowPop(false)}
          title={i18n.t('BEDSTATUS_TRANSFER_IN_BUTTON')}
          allData={editData}
          saveHandle={async (data) => {
            if (editSaveHandle) {
              (await editSaveHandle(data)) && setIsShowPop(false);
            }
          }}
          bsMlookupList={BsMlookupList}
          setRefresh={(callback) => {
            setRefresh(callback);
            bsTransferInStatisticRef?.current?.getTransferStatistic();
          }}
          setIsLoading={setIsLoading}
          bsMlookupListStatus={bsMlookupListStatus}
          wardLabel={i18n.t('BEDSTATUS_TI_UNIT')}
        />
      )}
      {loginPopup && <LoginPop closehandle={() => setLoginPopup(false)} submitHandle={() => setLoginPopup(false)} />}
    </div>
  );
}

export default connect((state) => ({
  loginInfo: state.loginInfo,
  userRole: state.userRole,
  rouList: state.rouList,
}))(InternalBooking);
